
import { Injectable } from '@angular/core';
import { ResourceService } from '@smartsoftware/reflex-core';
import { ServiceCategory } from '../models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Page, PageParams } from '../paged.datasource';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class ServiceCategory_Service extends ResourceService<ServiceCategory> {

    protected servicePath = '/ServiceCategory';

    public ModelType = ServiceCategory;

    constructor(
        protected http: HttpClient
    ) {
        super(http);
    }

    page(pageParams: PageParams): Observable<Page<ServiceCategory>> {
        let params = new HttpParams().append('params', encodeURIComponent(btoa(JSON.stringify(pageParams))));
        return this.http.get<Page<ServiceCategory>>(`${this.serviceUrl}Page`, { params })
            .pipe(map(page => {
                page.items = page.items.map(i => new ServiceCategory(i));
                return page;
            }));
    }
}